export default __webpack_public_path__ + "static/media/Zarrar_Resume.8995373b.pdf";